// Optional UI preferences only. Session, checkpoint and transaction storage must
// keep their own stricter failure semantics. React state owns the in-memory choice.
export function readOptionalPreference(key: string): string | null {
  try { return window.localStorage.getItem(key); }
  catch { return null; }
}

export function writeOptionalPreference(key: string, value: string): void {
  try { window.localStorage.setItem(key, value); }
  catch { /* The caller's in-memory choice remains usable for this page lifetime. */ }
}
